import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule, registerLazyOrchestrator, LazyImport } from 'owa-bundling';
import { selectPreviousNode } from 'owa-mail-actions/lib/selectPreviousNode';
import { validateDumpsterQuota } from 'owa-storage-store/lib/actions/validateDumpsterQuota';
import onFavoritesLoaded from 'owa-favorites/lib/actions/onFavoritesLoaded';
import { leaveGroupSuccess } from 'owa-groups-shared-actions/lib/leaveGroupSuccess';
import { selectDefaultFolderOnRemove } from 'owa-shared-folder';
import { unifiedInboxDisabledWhileActive } from 'owa-mail-actions';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "FolderForestActions"*/ './lazyIndex'),
    { name: 'FolderForestActions' }
);

export const lazyLoadDumpster: LazyAction<typeof lazyIndex.loadDumpster, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.loadDumpster);
export const lazyToggleFavoriteFolder: LazyAction<
    typeof lazyIndex.toggleFavoriteFolder,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.toggleFavoriteFolder);
export const lazySelectGroup: LazyAction<typeof lazyIndex.selectGroup, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.selectGroup);
export const lazySelectFavoriteCategory: LazyAction<
    typeof lazyIndex.selectFavoriteCategory,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.selectFavoriteCategory);
export const lazySelectPersona: LazyAction<typeof lazyIndex.selectPersona, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.selectPersona);

export const lazyLoadPopoutDataToFolderStore: LazyAction<
    typeof lazyIndex.loadPopoutDataToFolderStore,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.loadPopoutDataToFolderStore);
export const lazyLoadPopoutDataToPublicFolderFavoriteStore: LazyAction<
    typeof lazyIndex.loadPopoutDataToPublicFolderFavoriteStore,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.loadPopoutDataToPublicFolderFavoriteStore);

export const lazySelectGroupFolder: LazyAction<
    typeof lazyIndex.selectGroupFolder,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.selectGroupFolder);

export const lazyTryLoadAttachmentsSearchFolder: LazyImport<
    typeof lazyIndex.tryLoadAttachmentsSearchFolder,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.tryLoadAttachmentsSearchFolder);

registerLazyOrchestrator(selectPreviousNode, lazyModule, m => m.selectPreviousNodeOrchestrator);
registerLazyOrchestrator(
    validateDumpsterQuota,
    lazyModule,
    m => m.validateDumpsterQuotaOrchestrator
);
registerLazyOrchestrator(onFavoritesLoaded, lazyModule, m => m.onFavoritesLoadedOrchestrator);
registerLazyOrchestrator(leaveGroupSuccess, lazyModule, m => m.onLeaveGroupSuccessOrchestrator);
registerLazyOrchestrator(
    selectDefaultFolderOnRemove,
    lazyModule,
    m => m.selectDefaultFolderOrchestrator
);
registerLazyOrchestrator(
    unifiedInboxDisabledWhileActive,
    lazyModule,
    m => m.unifiedInboxDisabledWhileActiveOrchestrator
);
